import { ethereum } from '@0xtorch/core'
import { mode } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createModeChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}): Chain =>
  createModeChainCustom({
    client: createClient({
      chain: mode,
      httpRpcs: modeHttpRpcs,
    }),
    explorer: createBlockscout({
      useAddressApiV2: true,
      name: 'Mode Explorer',
      baseUrl: 'https://explorer.mode.network',
      apiBaseUrl: 'https://explorer.mode.network/api',
      proxyUrl,
    }),
  })

type CreateModeChainParameters = {
  client: Client
  explorer: Explorer
}

export const createModeChainCustom = ({
  client,
  explorer,
}: CreateModeChainParameters): Chain => ({
  id: 34_443,
  network: 'mode',
  name: 'Mode',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x4200000000000000000000000000000000000006',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'mode',
  defillamaId: 'mode',
})

export const modeHttpRpcs: HttpRpc[] = [
  {
    url: 'https://mainnet.mode.network',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://mode.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://1rpc.io/mode',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
]

export const modeWebsocketRpcUrls: readonly string[] = []
